import { styled } from '@mui/material';
import { FaIcon } from './faIcon';

export const RotatingIcon = styled(FaIcon, {
  shouldForwardProp: (prop: string) => !['active', 'activeAngle', 'inactiveAngle'].includes(prop),
})<{ active: boolean; activeAngle: number; inactiveAngle: number }>`
  transform: ${({ active, activeAngle, inactiveAngle }) =>
    active ? `rotate(${activeAngle}deg)` : `rotate(${inactiveAngle}deg)`};
  transition: transform 0.3s;
`;
